// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"a8013098","596":"cc195b91"}[chunkId] + ".chunk.js";
};